export type SeoTextClickOptions = {
  external?: boolean
  scrollBehavior?: 'auto' | 'smooth'
}

export function useSeoText() {
  const { buildValidUrl } = useURLs()

  function handleClick(event: MouseEvent, options?: SeoTextClickOptions) {
    const targetA = findTargetA(event)
    const href = targetA?.getAttribute('href')
    const target = targetA?.getAttribute('target') ?? '_blank'

    if (!href) return undefined

    if (href.startsWith('#')) {
      const element = document.getElementById(href.substring(1))

      element?.scrollIntoView({ behavior: options?.scrollBehavior ?? 'auto' })
    } else {
      navigateTo(buildValidUrl(href).toString(), {
        external: options?.external || target === '_blank',
        open: { target },
      })
    }
  }

  return { handleClick }
}
